<template>
    <div>
        <!--<div style="width: 50%;margin: 20px 0;">
            <span class="searchName" >品名/批次号:</span>
            <el-input
                    size="mini"
                    class="mr10"
                    placeholder="品名或批次号 搜索"
                    v-model="cpinput"
                    clearable>
            </el-input>
            <el-button type="primary" @click="searchData" style="margin-left: 30px" :class="baseerp+'btn'" size="mini">搜索</el-button>
        </div>-->
        <el-table
                :key="tableKey"
                v-if="showTable"
                size="mini"
                border
                ref="multipleTable"
                :data="detailsData"
                :row-key="row => row.i_id"
                height="220"
                tooltip-effect="dark"
                :row-class-name="tableRowClassName"
                :default-selection="defaultSelectedRows"
                @select="select"
                @select-all="allchoose"
                style="width: 100%">
            <!--row-key="i_pzid"-->
            <!--@selection-change="handleSelectionChange"-->
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column
                    align="left"
                    type="selection"
                    :selectable="isRowSelectable"
                    :reserve-selection="true"
                    width="55">
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="i_id"
                    :label="$t('invoiceEntry_cost_id')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_no"
                    :label="$t('form_order_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_xcode"
                    :label="$t('invoiceEntry_sales_order_number')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip>
                <template  slot-scope="scope">
                    <span>{{scope.row.vc_pzname+' '+scope.row.vc_cd+scope.row.vc_gykh+scope.row.vc_bzstyle}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="f_kglfpje"
                    :label="$t('invoiceEntry_can_be_associated_with_invoice_amount')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="center"
                    prop="f_je"
                    :label="$t('invoiceEntry_this_associated_invoice_amount')"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-input-number @change="inbcfnum(detailsData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_je" ></el-input-number>
                </template>
            </el-table-column>
            <!--<el-table-column  align="center"  width="50">
                &lt;!&ndash;<template slot="header" slot-scope="scope" >
                    <el-button class="popaddbtn" @click="popShow"  :disabled="isbtn" ><i class="el-icon-plus"></i></el-button>
                </template>&ndash;&gt;
                <template  slot-scope="scope" >
                    <div class="iconminus">
                        <span class="minus"  @click="deleteRow(scope.row,scope.$index)"><i class="el-icon-minus"></i></span>
                    </div>
                </template>
            </el-table-column>-->
            <!--<el-table-column
                    align="center"
                    prop="f_kglfpnum"
                    label="可关联发票数量"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column :label="$t('invoiceEntry_can_be_associated_with_invoice_amount')">
                <template slot-scope="{ row }">
                    {{ getRemaining(row.i_id) }}
                </template>
            </el-table-column>
            <el-table-column :label="$t('invoiceEntry_this_associated_invoice_amount')">
                <template slot-scope="{ row }">
                    <el-input-number
                            :precision="5"
                            :controls="false"
                            size="mini"
                            :value="getEditingQty(row.i_id)"
                            @input="val => onQtyChange(row, val)"
                    />
                </template>
            </el-table-column>-->
        </el-table>
        <div slot="footer" class="dialog-footer" style="text-align: center;margin-top: 20px">
            <el-button type="primary" @click="confirm" :class="baseerp+'btn'" size="small" :disabled="disabled">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    import Tender from "../../tender/index";
    export default {
        name: "ProductDetails",
        components: {Tender},
        props:{
            productDetails:{
                type:Object,
                required:true,
            },
            varieties: Array,
            invoices: Array
        },
        data() {
            return {
                tableKey: Date.now(),
                showTable:true,
                /*getRowKeys(row){
                    return row.i_pzid
                },*/
                i_htid:0,
                /****************/
                cpinput:"",
                multipleSelection:[],
                detailsData:[],
                /*currentPage:0,
                tableTotal:0,
                pageSize:1,
                pageCount:1,*/
                gsid:0,
                gsid_out:0,
                i_pzid:0,
                ckid:0,
                baseerp:"",
                mid:0,
                dataText:this.$t('tips_data_loading_in_progress'),
                disabled:false,
                selected:[],
                pzids:[],
                i_isfrom:1,
                currentInvoiceId: null,
                //editingSelections: [],
                fyid:[],
            }
        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.multipleSelection;
            }
        },
        mounted() {
            this.baseerp=baseerp;
            //console.log(this.productDetails,"new----productDetails");
            this.i_isfrom=this.productDetails.i_isfrom;
            if(this.productDetails.row.i_id==0){
                this.detailsData=this.productDetails.selected;
            }else{
                this.detailsData=this.productDetails.row.details
                ;
            }
            this.multipleSelection = this.productDetails.row.details;
            this.currentInvoiceId = this.productDetails.index;
            this.$nextTick(() => {
                const table = this.$refs.multipleTable;
                if (table) {
                    this.detailsData.forEach(row => {
                        const isSelected = this.multipleSelection.some(sel => sel.i_id === row.i_id);
                        const idx = this.multipleSelection.findIndex(sel => sel.i_id === row.i_id);
                        //console.log(isSelected,'isSelected',idx,'idx')
                        if(isSelected){
                            row.f_je=this.multipleSelection[idx].f_je
                        }
                        table.toggleRowSelection(row, isSelected);
                    });
                }
            });

        },
        methods: {
            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                })
            },
            isRowSelectable(row,index){
                //console.log(row,'row')
                if(this.productDetails.row.i_id==0){
                    if (row.disabled) {
                        return false;
                    } else {
                        return true;
                    }
                }else{
                    if(!row.disabled){
                        return false
                    }else{
                        return true
                    }
                }
            },
            deleteRow(value,index){
                if(value.i_id){
                    this.fyid.push(value.i_id);
                };
                this.detailsData.splice(index,1);
                this.multipleSelection.splice(index,1);
            },

            getEditingQty(varietyId) {
                const item = this.multipleSelection.find(v => v.i_id === varietyId);
                return item ? item.f_je : 0;
            },
            getUsed(varietyId) {
                return this.productDetails.invoices.reduce((sum, inv) => {
                    if (inv.index === this.currentInvoiceId){
                        //console.log(sum,'sum')
                        return sum;
                    }
                    const item = inv.details.find(v => v.i_id === varietyId);
                    return sum + (item ? item.f_je : 0);
                }, 0);
            },
            getRemaining(varietyId) {
                const variety = this.productDetails.varieties.find(v => v.i_id === varietyId);
                //console.log(variety,'variety')
                //console.log(this.getUsed(varietyId),'this.getUsed(varietyId)')
                return variety ? variety.unAssociatedAmount - this.getUsed(varietyId) : 0;
            },
            onQtyChange(row, val) {
                const qty = Number(val) || 0;
                const variety =  this.productDetails.varieties.find(v => v.i_id === row.i_id);
                if (!variety) return;

                // 查找其他发票对该品种的使用总量（排除当前发票）
                let totalUsed = 0;
                this.productDetails.invoices.forEach(inv => {
                    if (inv.index === this.currentInvoiceId) return;
                    const item = inv.details.find(v => v.i_id === row.i_id);
                    if (item) totalUsed += item.f_je;
                });

                // 查找本弹窗中是否已选过该品种
                const existing = this.multipleSelection.find(v => v.i_id === row.i_id);
                const oldQty = existing ? existing.f_je : 0;
                const remaining = variety.unAssociatedAmount - totalUsed;

                if (qty > remaining) {
                    this.$message.error(this.$t('invoiceEntry_exceeding_the_relatable_quantity')+'（'+this.$t('invoiceEntry_remaining') +this.remaining+'）！');
                    return;
                }

                if (existing) {
                    existing.f_je = qty;
                } else {
                    this.multipleSelection.push({
                        ...variety,
                        varietyId: variety.i_id,
                        f_je: qty
                    });
                }
            },
            inbcfnum(data,index,row){
                if(row.f_je <= 0){
                    row.f_je = row.f_kglfpje;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_amount_cannot_be_less_than_or_equal_to_0'));
                    this.refreshTable();
                    return ;
                }
                if(row.f_je > row.f_kglfpje){
                    row.f_je = row.f_kglfpje;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_amount_of_this_associated_invoice_cannot_exceed_the_amount_of_the_invoice_that_can_be_associated'));
                    this.refreshTable();
                    return ;
                }
                this.$set(data,index,row);
                //console.log(this.detailsData,this.multipleSelection,'sss')
                const idx = this.multipleSelection.findIndex(sel => sel.i_id === row.i_id);
                if (idx !== -1) {
                    this.multipleSelection[idx].f_je = row.f_je;
                }

            },
            //列表
            async getPzListByHtid(){
                let param={
                    //i_type:this.productDetails.i_type,
                    i_id:this.productDetails.i_id,
                    i_khtype:this.productDetails.i_khtype,
                    i_kpkhid: this.productDetails.i_kpkhid,
                    i_gsid:this.productDetails.i_gsid,
                    //f_fpnum:this.productDetails.row.f_fpnum,
                    //vc_fpunit:this.productDetails.row.vc_fpunit,
                    //vc_search: '',
                    //vc_fppzname:this.productDetails.row.vc_fppzname,
                    vc_no:this.productDetails.orderWs,
                    i_isfrom:this.productDetails.i_isfrom,
                };
                let res=await API.pzlist(param);
                if(res.code==1){
                    if (res.data.list.length==0){
                        this.dataText=this.$t('tips_no_data_available_at_the_moment')
                    }
                    this.detailsData=res.data.list;
                    //console.log('this.detailsData',this.detailsData)
                    this.$nextTick(() => {
                        const table = this.$refs.multipleTable;
                        if (table) {
                            this.detailsData.forEach(row => {
                                //console.log(this.multipleSelection,'1====')
                                const isSelected = this.multipleSelection.some(sel => sel.i_id === row.i_id);
                                //console.log(isSelected,'isSelected')
                                table.toggleRowSelection(row, isSelected);
                            });
                        }
                    });
                    /*this.$nextTick(()=>{
                        for(let i=0;i<this.detailsData.length;i++){
                            let pz= this.detailsData[i];
                            for(let s of this.productDetails.selected){
                                if(pz.i_pzid==s.i_pzid){
                                    this.$refs.multipleTable.toggleRowSelection(this.detailsData[i],true)
                                }
                            }
                        }
                    });*/
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            searchData(){
                this.detailsData=[];
                /*this.pageSize=1;
                this.currentPage=1;*/
                //this.getWarehousingProductList();
            },
            cancel(){
                this.$emit('closePop');
            },
            allchoose(val){
                val.forEach(item => item.f_je=item.f_kglfpje);
                this.multipleSelection=val;
            },
            select(val,row){
                row.f_je=row.f_kglfpje;
                this.multipleSelection=val;
            },

            tableRowClassName({row,rowIndex}){
                //console.log(row.i_gsid,this.gsid)
                /*if(row.i_gsid!=this.gsid){
                    return 'danger-row';
                }*/
                if (row.isother == 1) {
                    return 'danger-row';
                }
            },
            confirm() {
                //console.log(this.multipleSelection,'this.multipleSelection')
                if(this.multipleSelection.length==0){
                    this.$message.error(this.$t('invoiceEntry_please_select_the_cost'));
                    return
                }
                let total=0;
                this.multipleSelection.forEach(item=>{
                    item.f_sl=this.productDetails.row.f_sl
                    total += item.f_je
                })
                //console.log('total',Number(total));
                //console.log('f_pay',Number(this.productDetails.f_pay));
                if(Number(total)!=Number(this.productDetails.f_pay)){
                    this.$message.error(this.$t('invoiceEntry_the_total_amount_of_this_associated_invoice_must_be_consistent_with_the_invoice_inclusive_of_taxes'));
                    return
                }
                //console.log(this.multipleSelection,'this.multipleSelection')
                this.$emit('confirm', {
                    invoiceId: this.currentInvoiceId,
                    selections: JSON.parse(JSON.stringify(this.multipleSelection)),
                    fyid:this.fyid
                });
                this.$emit('closePop');
            },

            pageCurrentChange(val){
                this.detailsData=[];
                /*this.pageSize=val;
                this.currentPage=val;*/
                //this.getWarehousingProductList();
            },
            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
        },
    }
</script>

<style lang="scss" scoped>
.searchName{
    width: 100px; display: inline-block;vertical-align: middle;text-align: center;
}
    .mr10{
        width: 50%;
    }

/deep/{
    .danger-row{
        color: #999;
    }
}
</style>